module.exports = __webpack_public_path__ + "images/videoCaseStudy-mandel-logo.png?h=362676efac9f7e78fa4f62e7f24148e0";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-logo.png
// module id = 2105
// module chunks = 12 15